<template>
  <div class="workspace">
    <TopHeader />
    <div class="wrapper">
      <b-container>
        <b-row class="buttons">
          <b-button variant="info" @click="func1();">Type1</b-button>
          <b-button variant="info" @click="func2()">Type2</b-button>
          <b-button variant="info" @click="func3()">Type3</b-button>
          <b-button variant="info" @click="func4()">Type4</b-button>
        </b-row>
      </b-container>
      <b-container class="panel">
        <b-row>
          <Jimun />
        </b-row>
      </b-container>
      <b-container class="panel">
        <JimunSvg />
      </b-container>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/Header";
import Jimun from "@/components/Jimun";
import JimunSvg from "@/components/JimunSvg";
export default {
  components: { TopHeader, Jimun, JimunSvg },
  data() {
    return {
      mode: 0,
    };
  },
  methods: {
    func1() {
      alert("x");
    },
    func2() {
      alert("x2");
    },
    func3() {
      alert("x3");
    },
    func4() {
      alert("x4");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.wrapper {
  padding-top: 50px;
}
.panel {
  border-radius: 5px;
  border: 1px solid $gray100;
  background-color: white;
  //   height: 120px;
  min-height: 120px;
  box-shadow: 3px 3px 3px $gray200;
  margin-bottom: $item-margin-bottom;
}

.buttons button {
  margin-right: 5px;
}
.buttons button:last-child {
  margin-right: 0px;
}
</style>